/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TimelineContent } from '../../models/timeline-content';

export interface ApiMasterTimelineContentGetByIdGet$Params {
  id?: string;
}

export function apiMasterTimelineContentGetByIdGet(http: HttpClient, rootUrl: string, params?: ApiMasterTimelineContentGetByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TimelineContent>> {
  const rb = new RequestBuilder(rootUrl, apiMasterTimelineContentGetByIdGet.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TimelineContent>;
    })
  );
}

apiMasterTimelineContentGetByIdGet.PATH = '/api/Master/TimelineContent/GetById';
